<label class="esf-form-item__label">{{ label }}<app-optional *ngIf="optional"></app-optional></label>
<div #toggleButton class="form-icon" (click)="openIconPicker()">
  <svg class="esf-icon esf-button__icon displayed-icon" width="48" height="48">
    <use [attr.xlink:href]="'#esf-icon-' + icon"></use>
  </svg>
  <input type="button"
         autocomplete="off"
         [formControl]="formControl"
         [id]="id"
         [readOnly]="true">
</div>

<div #iconPicker class="icon-picker" [ngClass]="{'open': isOpen}">
  <div class="icon-picker--icon" *ngFor="let icon of icons">
    <svg (click)="setIcon(icon)" class="esf-icon" width="48" height="48">
      <use [attr.xlink:href]="'#esf-icon-' + icon"></use>
    </svg>
  </div>
</div>
